export class Usuario {
    id: string;
    nombresCompletos: string;
    dni: string;
    email: string;
}